<template>
  <div>
    <PrintedLicenses />
  </div>
</template>

<script>
import PrintedLicenses from '@/nfmp_components/printedLicenses.vue'
export default {
  components: {
    PrintedLicenses
  }
}
</script>